import { Injectable } from '@angular/core';
import { shareReplay, switchMap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { ContentService } from '@common/services/content.service';

export interface MenuItem {
    cmsKey: string,
    id: string
    url?: string,
    isExternalLink?: boolean,
    children?: MenuItem[]
}

@Injectable({
  providedIn: 'root'
})
export class MenuService {
  menuItems: MenuItem[];
  shouldShowWebinars$: Observable<boolean>;

  constructor(private contentService: ContentService) {
      this.shouldShowWebinars$ = this.contentService.valueExists('info-item-webinars-header').pipe(
          shareReplay(1)
      );
  }


  getInfoItems(): MenuItem[] {
    return this.getFlatMenuItems().filter(i =>  i?.url?.includes('/info/'));
  }

  getInfoItemSpecificUrlSegment(id: string): Observable<string> {
    return this.contentService.valueExists(`info-item-${id}-url`).pipe(
        switchMap((exists) => exists ? this.contentService.value(`info-item-${id}-url`) : of(id))
    );
}

  private getFlatMenuItems(): MenuItem[] {
    const flatMenuItems: MenuItem[] = [];

    this.menuItems?.forEach(item => {
        flatMenuItems.push(item);
        if (item.children) {
            flatMenuItems.push(...item.children);
        }
    });

    return flatMenuItems
  }
}
